export default "__VITE_ASSET__DawP6Dts__"